import useScroll from "~/compositions/useScroll";
import useElementPosition from "~/compositions/useElementPosition";
import { isset } from "~/utils/helpers";
export default class StickyMenu {
    stickyMenu;
    stickySearch;
    mainSearch;
    blogSearch;
    timeout = null;
    constructor() {
        this.stickyMenu = document.querySelector('.js-sticky-navigation-menu');
        this.stickySearch = document.querySelector('.js-sticky-search-form');
        this.mainSearch = document.querySelector('.js-main-search-form');
        this.blogSearch = document.querySelector('.js-blog-search');
        const { scrollY, scrollCallback, nativeInit } = useScroll(16, false);
        scrollCallback.value = () => {
            this.scrolled(scrollY.value);
        };
        nativeInit();
        this.scrolled(window.scrollY);
    }
    scrolled(scrollY, recall = false) {
        if (this.stickyMenu) {
            if (scrollY > 120)
                this.stickyMenu.classList.add('is-active');
            else
                this.stickyMenu.classList.remove('is-active');
        }
        if (this.stickySearch) {
            const { givenElementRelatedInViewport } = useElementPosition(false);
            if (this.stickyMenu)
                this.stickySearch.style.top = this.stickyMenu.offsetHeight + 'px';
            let position = null;
            if (this.mainSearch)
                position = givenElementRelatedInViewport(this.mainSearch);
            else if (this.blogSearch)
                position = givenElementRelatedInViewport(this.blogSearch);
            if (position) {
                if (position.aboveViewport)
                    this.stickySearch.classList.add('is-active');
                else
                    this.stickySearch.classList.remove('is-active');
            }
        }
        if (!recall) {
            if (isset(this.timeout))
                clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                this.scrolled(scrollY, true);
            }, 500);
        }
    }
}
